import React, {Component} from 'react';
import {connect} from 'react-redux';

class PlayerRank extends Component {
    render() {
        const {mode, modesConfig} = this.props;
        const modeConfig = modesConfig.getConfig(mode);

        if (isEmpty(modeConfig)) {
            return null;
        }

        return <>{modeConfig.getLabel()}</>;
    }
}

function mapStatesToProps(state) {
    const {modesConfig} = state;

    return {
        modesConfig,
    };
}

export default connect(mapStatesToProps)(PlayerRank);
